module.exports = __webpack_public_path__ + "a4aa890d65cbdec775473f8be90ba4b1.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/corrientes tenis.png
// module id = 595
// module chunks = 0